// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { getPostalCodePattern } from './postalCodePatternPerCountry';
import { provinceValidation } from './provinceRequiredPerCountry';

export const validationPatterns = {
    email:
        '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    phoneNumber:
        '^\\+?([1-9]?[0-9]+[\\-\\)\\(\\s]?[0-9]+[\\-\\)\\(\\s]?[0-9]+[\\-\\)\\(\\s]?[0-9]+)$',
    serialNumber: '^[0-9A-Z]{12,18}$',
    orderNumber: '^CO[0-9A-Z]{10}$|^[0-9]+$',
    microsoftUser: '^[a-zA-Z0-9._%+-]+@microsoft.com',
};

export function validationByPattern(pattern?: string, value?: string) {
    if (!pattern || !value) {
        return true;
    }

    return new RegExp(pattern, 'i').test(value);
}

export function validatePostalCode(
    countryCode: string = '',
    postalCode: any
): boolean {
    const validationData =
        getPostalCodePattern(countryCode.toLowerCase()) || {};
    const { regex } = validationData;
    return validationByPattern(regex, postalCode);
}

export function validateProvince(
    countryCode: string = '',
    region?: string
): boolean {
    const validationData = provinceValidation[countryCode.toLowerCase()] || {};
    const { required } = validationData;
    if (required) {
        if (!region) {
            return false;
        }
        return true;
    }
    return true;
}

export function validateSerialNumber(serialNumber?: string) {
    return validationByPattern(validationPatterns.serialNumber, serialNumber);
}

export function validateOrderNumber(orderNumber?: string) {
    return validationByPattern(validationPatterns.orderNumber, orderNumber);
}

export function validateEmail(email?: string): boolean {
    return validationByPattern(validationPatterns.email, email);
}

export function validatePhoneNumber(phoneNumber?: string): boolean {
    return validationByPattern(validationPatterns.phoneNumber, phoneNumber);
}

export function validateMicrosoftUser(email?: string): boolean {
    return validationByPattern(validationPatterns.microsoftUser, email);
}
